import { render, staticRenderFns } from "./list-input-text.vue?vue&type=template&id=88c4849e&"
import script from "./list-input-text.vue?vue&type=script&lang=ts&"
export * from "./list-input-text.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_wzvh6gi4tchptuexh7cjhim74e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports